/* eslint-disable max-len */
import React from 'react';

import Icon from '@mui/icons-material/FollowTheSigns';

const TourHelpIcon = ({ ...props }) => <Icon {...props} />;

export default TourHelpIcon;
